module.exports = __webpack_public_path__ + "img/icon_pin2.37beaec1.png";